/**
 * The host's colour and photo crop from the QR landing (050), so the card is
 * drawn in its final colour and framing from the first frame — the reply
 * carries the same values, so nothing changes when it lands (Mark 2026-10-20,
 * the purple flash). Additive keys, each only when present: an older landing
 * row adds nothing.
 */
export const prefetchedLook = (serverData) => ({
  ...(serverData?.profileColour ? { colour: serverData.profileColour } : {}),
  ...(serverData?.profilePhotoMeta ? { photoMeta: serverData.profilePhotoMeta } : {}),
});
